export function UpdateHTMLSpinnerText(message) {
  var elem = document.getElementById("spinner-text");
  if (elem == null) return;
  elem.innerText = message;
  return elem;
}
